import clsx from 'clsx';

import type { CaraAttachmentError } from '~/components/cara-input/use-attachment-validation';
import { type CopilotActionError, normalizeCopilotActionError } from '~/lib/copilot-action-error';
import { OverageLimitErrorBanner } from '~/components/overage-limit-error';

/**
 * Renders the validation-error list (from `useAttachmentValidation`) plus an
 * optional submit-error from the parent. Returns `null` when there's nothing
 * to show, so callers can drop it unconditionally into the layout.
 */
export const CaraInputErrors = (props: {
  attachmentErrors: CaraAttachmentError[];
  submitError?: CopilotActionError | string;
  className?: string;
}) => {
  const normalized = normalizeCopilotActionError(props.submitError);
  if (props.attachmentErrors.length === 0 && !normalized) return null;

  if (normalized?.kind === 'overage') {
    return (
      <div className={clsx('mt-2 flex flex-col gap-2', props.className)}>
        {props.attachmentErrors.length > 0 && (
          <div
            role="alert"
            aria-live="polite"
            className="flex flex-col gap-1 text-sm/5 text-red-600 sm:text-xs/4 dark:text-red-500"
          >
            {props.attachmentErrors.map((err) => (
              <div key={`${err.code}-${err.attachmentId}`}>{err.message}</div>
            ))}
          </div>
        )}
        <OverageLimitErrorBanner message={normalized.message} />
      </div>
    );
  }

  return (
    <div
      role="alert"
      aria-live="polite"
      className={clsx(
        'mt-2 flex flex-col gap-1 text-sm/5 text-red-600 sm:text-xs/4 dark:text-red-500',
        props.className
      )}
    >
      {props.attachmentErrors.map((err) => (
        <div key={`${err.code}-${err.attachmentId}`}>{err.message}</div>
      ))}
      {normalized && <div>{normalized.message}</div>}
    </div>
  );
};
